import { formatDatetime } from 'helpers/timezone';

import DocumentCardNew from 'components/cards/document_new';
import Loading from 'components/loading/loading';

const CustomerDocuments = ({ loading, documents }) => {
  if (loading) return <Loading />;
  if (!documents) return null;

  return (
    <div style={{ padding: '32px 24px', background: 'white' }}>
      <section
        style={{ backgroundColor: 'white' }}
        className="flex flex-column"
      >
        {documents.map((doc, index) => (
          <DocumentCardNew
            key={index}
            data={doc}
            date={formatDatetime(doc.createdAt)}
          />
        ))}
      </section>
    </div>
  );
};
export default CustomerDocuments;
